export var Routes;
(function (Routes) {
    Routes["BASE"] = "/";
    Routes["ABOUT"] = "/about";
    Routes["SOBOO"] = "/soboo";
    /**
     * This is added for backwards compatibility
     * in order to keep the links in the marketing
     * website and in the core app working.
     */
    Routes["SOURCE"] = "/source";
    Routes["SOURCES"] = "/sources";
    /**
     * This is added for backwards compatibility
     * in order to keep the links in the marketing
     * website and in the core app working.
     */
    Routes["FORWARDER"] = "/forwarder";
    Routes["FORWARDERS"] = "/forwarders";
})(Routes || (Routes = {}));
